import { Injectable } from '@angular/core';

import { AppState } from '../app-state';

import { ScoutPointLocalPhotoUrl } from '../models/scout-task';
import { ScoutLocalDbService, TestbedDexieCollectionService } from './scout-local-db.service';


@Injectable({ providedIn: 'root' })
export class ScoutPointLocalPhotoUrlService extends TestbedDexieCollectionService<ScoutPointLocalPhotoUrl> {

  constructor( 
      appState : AppState, 
      protected scoutLocalDb: ScoutLocalDbService ) {
    super(appState)
  }

  get dexieStore(){
    return this.scoutLocalDb.scoutPointLocalPhotoUrls
  }

}